import { render, staticRenderFns } from "./MonthlyNotRenewalsPerLicence.vue?vue&type=template&id=e24f50b4"
import script from "./MonthlyNotRenewalsPerLicence.vue?vue&type=script&lang=js"
export * from "./MonthlyNotRenewalsPerLicence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports